export const BASEURL =
  process.env.REACT_APP_NODE_ENV === "development"
    ? "http://localhost:4000"
    : "https://treasurehuntapi.friftysearch.com";
